import { baseUrl } from "../../utils/env";
import axios from "axios";
import {
  EVENT_ADD_FAIL,
  EVENT_ADD_REQUEST,
  EVENT_ADD_SUCCESS,
  EVENT_DELETE_FAIL,
  EVENT_DELETE_REQUEST,
  EVENT_DELETE_SUCCESS,
  EVENT_DETAILS_FAIL,
  EVENT_DETAILS_REQUEST,
  EVENT_DETAILS_SUCCESS,
  EVENT_LIST_FAIL,
  EVENT_LIST_REQUEST,
  EVENT_LIST_SUCCESS,
  EVENT_UPDATE_FAIL,
  EVENT_UPDATE_REQUEST,
  EVENT_UPDATE_SUCCESS,
} from "../constants/eventsConstant";
import { toast } from "react-toastify";

export const listEvents = () => async (dispatch) => {
  try {
    dispatch({ type: EVENT_LIST_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/event`, config);

    dispatch({
      type: EVENT_LIST_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: EVENT_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const detailEvent = (uuid) => async (dispatch) => {
  try {
    dispatch({ type: EVENT_DETAILS_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/event/${uuid}`, config);

    dispatch({
      type: EVENT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: EVENT_DETAILS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const addEvent =
  (title, date, venue, description) => async (dispatch, getState) => {
    try {
      dispatch({ type: EVENT_ADD_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.post(
        `${baseUrl}/event`,
        {
          title,
          date,
          venue,
          description,
        },
        config
      );

      toast.info("Event Added Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: EVENT_ADD_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Add Event", {
        autoClose: 1000,
      });
      dispatch({
        type: EVENT_ADD_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
export const updateEvent =
  (title, date, venue, description, eventId) => async (dispatch, getState) => {
    try {
      dispatch({ type: EVENT_UPDATE_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseUrl}/event/${eventId}`,
        {
          title,
          date,
          venue,
          description,
        },
        config
      );

      toast.info("Event Updated Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: EVENT_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail to Update Event", {
        autoClose: 1000,
      });
      dispatch({
        type: EVENT_UPDATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
export const deleteEvent = (eventId) => async (dispatch, getState) => {
  try {
    dispatch({ type: EVENT_DELETE_REQUEST });
    const {
      adminLogin: { adminInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };
    const { data } = await axios.delete(`${baseUrl}/event/${eventId}`, config);

    toast.info("Event Deleted Successfully", {
      autoClose: 1000,
    });
    dispatch({
      type: EVENT_DELETE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    toast.error("Fail to Delete Event", {
      autoClose: 1000,
    });
    dispatch({
      type: EVENT_DELETE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
